import {
  mutationNames
} from '@/store/storeKeysettings'

const state = {
  ImageGalleries: {
    Parent: {
      'Id': 0,
      'PageTitle': '',
      'RowCreated': null,
      'RowUpdated': null,
      'SubscriptionModuleActivation_Id': 0,
      'HeaderElements': '',
      'FooterElements': '',
      'UseCategories': false,
      'PostCategories': null,
      'AllowLikes': false,
      'AllowSharing': false
    },
    'Galleries': []
  },
  'AlbumTabsInit': false,
  'SelectedAlbumtab': '',
  'ActiveAlbumCategory': '',
  'NewGallerieAlbum': null
}

const mutations = {
  [mutationNames.SET_IMAGEGALLERIE](state, ImageGalleries) {
    state.ImageGalleries = ImageGalleries
  },
  [mutationNames.SET_IMAGE_GALLERIE_PARENT](state, parent) {
    state.ImageGalleries.Parent = parent
  },
  [mutationNames.SET_ACTIVE_ALBUM_CATEGORY](state, ActiveAlbumCategory) {
    state.ActiveAlbumCategory = ActiveAlbumCategory
  },
  [mutationNames.SET_IMAGE_GALLERIE_ALBUMS](state, galleries) {
    state.ImageGalleries.Galleries = galleries
  },
  SetAlbumTabsInit(state, value) {
    state.AlbumTabsInit = value
  },
  [mutationNames.ADD_IMAGELIKE](state, payload) {
    for (let galleries of state.ImageGalleries.Galleries) {
      for (let albums of galleries.Albums) {
        if (albums.Id === payload.Album_Id) {
          albums.Images.forEach(image => {
            if (image.Id === payload.Reference_Id) {
              image.IsLiked = payload.Liked
              payload.Liked ? image.Likes++ : image.Likes--
            }
          })
          payload.Liked ? albums.Likes++ : albums.Likes--
          break
        }
      }
    }
  },
  SET_SELECTED_ALBUM_TAB(state, value) {
    state.SelectedAlbumtab = value
  },
  [mutationNames.CREATE_NEW_IMAGE_GALLERIE_ALBUM](state, gallerieAlbum) { // Use only when devsim reflection shows.
    state.NewGallerieAlbum = gallerieAlbum
  }
}

const actions = {
  initImageGalleriesData: ({
    commit
  }) => {
    commit(mutationNames.SET_IMAGEGALLERIE)
  },
  initImageGalleriesParent: ({
    commit
  }) => {
    commit(mutationNames.SET_IMAGE_GALLERIE_PARENT)
  },
  initImageGalleriesAlbums: ({
    commit
  }) => {
    commit(mutationNames.SET_IMAGE_GALLERIE_ALBUMS)
  },
  initAlbumTab({
    commit
  }, payload) {
    commit('SetAlbumTabsInit', payload)
  },
  addUpdateImageLike: ({
    commit
  }, payload) => {
    commit(mutationNames.ADD_IMAGELIKE, payload)
  },
  setSelectedAlbumTab: ({
    commit
  }, payload) => {
    commit('SET_SELECTED_ALBUM_TAB', payload)
  },
  setActiveAlbumCategory: ({ commit }, category) => {
    commit(mutationNames.SET_ACTIVE_ALBUM_CATEGORY, category)
  },
  setNewGallerieAlbum: ({ commit }, gallerieAlbum) => { // Use only when devsim reflection shows.
    commit(mutationNames.CREATE_NEW_IMAGE_GALLERIE_ALBUM, gallerieAlbum)
  }
}

const getters = {
  ImageGalleries: state => {
    return state.ImageGalleries
  },
  AlbumTabsInit: state => {
    return state.AlbumTabsInit
  },
  SelectedAlbumtab: state => state.SelectedAlbumtab,
  ActiveAlbumCategory: state => state.ActiveAlbumCategory,
  ImageGallerieParent: state => state.ImageGalleries.Parent,
  Galleries: state => state.ImageGalleries.Galleries,
  NewGallerieAlbum: state => state.NewGallerieAlbum
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/imageGalleries.js